module.exports = __webpack_public_path__ + "static/media/dragon1.95a8dac4.png";